import { render, staticRenderFns } from "./EformElementEditText.vue?vue&type=template&id=ac00a480&scoped=true&"
import script from "./EformElementEditText.vue?vue&type=script&lang=js&"
export * from "./EformElementEditText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac00a480",
  null
  
)

export default component.exports